const STORAGE_KEY = 'roupoo-cart'
const localStoragePlugin = store => {
  store.subscribe((mutation, state) => {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state.cart.added))
  })
}

export default [localStoragePlugin]



// WEBPACK FOOTER //
// ./src/store/plugins.js